export enum EMenuSistema {
    PainelNegocio = 'Painel de Negócio',
    Admin = 'Admin',
    Configuracao = 'Configuração',
    ConfiguracaoCadastro = 'Cadastro',
    Cadastro = 'Cadastro',
    Negocio = 'Negócio',
    PerfilUsuario = 'Perfil Usuário',
    PainelOperacional = 'Painel Operacional',
    Operacional = 'Operacional',
    Dashboard = 'Dashboard',
    RecursosHumanos = 'Recursos Humanos'
}
